import {
    agriAlertGetCropsSpray,
    agriAlertGetStressAlertData,
    getTemplateOptions,
} from '@/util/Request/agrialert';
import {
    IGetCorpsSprayReqModel,
    IGetStressAlertReqModel,
    ISprayLegendsModel,
    ISprayLegendsValuesModel,
    ITemplateOptionsDetailResModel,
    ITemplateOptionsResModel,
} from '@/util/Request/agrialert/requestType';
import {
    IAgriAlertTranslateResModel,
    IGetCorpsSprayResModel,
    IGetStressAlertDataResModel,
} from '@/util/Request/agrialert/responseType';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { getWeekTranslate } from '../../initData';
import './index.less';
import IF from '@/components/IF';

interface IProp {
  showSpray: boolean;
  allStressAlertReq: IGetCorpsSprayReqModel[];
  translateValue: IAgriAlertTranslateResModel;
  languageCode: string;
}
interface IFinalSprayDataModel {
  id: string;
  name: string;
  legendsGroup?: string;
  data: IGetCorpsSprayResModel;
}

interface IFinalSprayRenderModel{
    legendsGroup: string;
    currentSprayReqData: IFinalSprayDataModel[];
    legendsValues: ISprayLegendsValuesModel[][];
}

const TemplateSpray = (prop: IProp) => {
    const { showSpray, allStressAlertReq, translateValue, languageCode } = prop;

    const finalFormat = languageCode === 'fr' ? 'DD/MM' : 'MM/DD';

    const [currentSprayReqData, setCurrentSprayReqData] = useState<IFinalSprayDataModel[]>([]);
    const [templateOptions,setTemplateOptions]=useState<ITemplateOptionsResModel>();

    const [currentSprayReqDataForForecast, setCurrentSprayReqDataForForecast] = useState<IFinalSprayDataModel[]>([]);
    const [currentSprayReqDataForHistorical, setCurrentSprayReqDataForHistorical] = useState<IFinalSprayDataModel[]>([]);
    const [currentSprayReqDataForMixed, setCurrentSprayReqDataForMixed] = useState<IFinalSprayDataModel[]>([]);

    // after group by legendsGroup, the final render data
    const [finalSprayRenderData, setFinalSprayRenderData] = useState<IFinalSprayRenderModel[]>([]);
    const [finalSprayRenderDataForForecast, setFinalSprayRenderDataForForecast] = useState<IFinalSprayRenderModel[]>([]);
    const [finalSprayRenderDataForHistorical, setFinalSprayRenderDataForHistorical] = useState<IFinalSprayRenderModel[]>([]);
    const [finalSprayRenderDataForMixed, setFinalSprayRenderDataForMixed] = useState<IFinalSprayRenderModel[]>([]);

    const [currentMixedToday,setCurrentMixedToday] = useState<string>(null);

    const [repeatRequest, setRepeatRequest] = useState<string[]>([]);
    const [finalRequestStressAlertReq, setFinalRequestStressAlertReq] = useState<IGetCorpsSprayReqModel[]>([]);

    useEffect(() => {
        if (!allStressAlertReq?.length) {
            setFinalRequestStressAlertReq([]);
            setRepeatRequest([]);
            return;
        }

        const alreadyKeys: string[] = [];
        const tmpFinalList: IGetCorpsSprayReqModel[] = [];
        const tmpRepeatKeys: string[] = [];

        allStressAlertReq.forEach((item) => {
            // const tmpKey = `${item.startDate}#${item.endDate}#${item.sprayingType}`;
            const tmpKey = `${item.sprayingType}#${item.startDate}#${item.endDate}`;

            if (alreadyKeys.includes(tmpKey)) {
            // 如果已存在，说明是重复项，记录这个 key
                tmpRepeatKeys.push(tmpKey);
            } else {
            // 第一次出现，加入最终列表
                tmpFinalList.push(item);
                alreadyKeys.push(tmpKey);
            }
        });
        setFinalRequestStressAlertReq(tmpFinalList);
        setRepeatRequest(tmpRepeatKeys);
    }, [allStressAlertReq]);

    const getTemOptions=async()=>{
        const response=await getTemplateOptions();
        setTemplateOptions(response.data);
    };

    // get spray windows data
    const getSprayListDataFunc = async () => {
        try {
            // 创建一个数组来存储所有的 promise
            const promises = finalRequestStressAlertReq?.map(async (item) => {
                return getSprayWindowsDataFuc(item);
            });
            // 使用 Promise.all 等待所有的 promise 完成
            const results = await Promise.all(promises);

            // 处理结果
            console.log('All spray windows data:', results);
            setCurrentSprayReqData(results?.flat());

            // 你可以在这里处理 results 数组，它包含了每个 sprayType 对应的喷洒窗口数据
            // 例如，将结果设置到某个状态或进行其他处理
            // setSprayWindowData(results); // 假设你有一个函数来处理这些数据

            return results; // 返回所有结果
        } catch (error) {
            console.error('Failed to get spray list data, error is: ', error);
            return null;
        }
    };
    const getSprayWindowsDataFuc = async (
        requestModel: IGetCorpsSprayReqModel
    ) => {
        try {
            // console.log('lanxue requestModel',requestModel);
            const res = await agriAlertGetCropsSpray(requestModel);
            // translate the week name
            // const format = languageCode === 'fr' ? 'DD/MM/YYYY' : 'MM/DD/YYYY';
            const finalRenderFormat = languageCode === 'fr' ? 'DD/MM' : 'MM/DD';
            res?.data?.lstSpray?.forEach((item, index) => {
                // const dayOfWeek = moment(item?.date,'MM/DD/YYYY')?.day();
                const dayOfWeek = moment(item?.date, 'YYYY-MM-DD')?.day();

                res.data.lstSpray[index].originDate = res.data.lstSpray[index].date;
                res.data.lstSpray[index].date =
          moment(item?.date, 'YYYY-MM-DD').format(finalRenderFormat) +
          ' ' +
          getWeekTranslate(translateValue, dayOfWeek);
            });
            // setSprayWindowData(res.data);
            // const name = sprayOptions.find( x=> x.code === sprayVariables).name;
            let code = '';
            if (requestModel?.sprayingType === 'SW_Ground_HLFM') {
                code = 'sW_Ground_HLFM';
            } else if (requestModel?.sprayingType === 'SW_Vixeranbiostim') {
                code = 'sW_Vixeranbiostim';
            } else if (requestModel?.sprayingType === 'SW_Vixeranbiostim_EU') {
                code = 'sW_Vixeranbiostim_EU';
            } else {
                code = requestModel?.sprayingType;
            }
            return {
                id: requestModel?.sprayingType,
                name: translateValue?.[code],
                data: res.data,
            };
        } catch (error) {
            return null;
            console.log('get spray windows data failed, error is ', error);
        }
    };

    // 将 legendValues 每三个分为一组，不足的补空数据
    const groupLegendValues = (values: ISprayLegendsValuesModel[], groupSize = 3) => {
        const grouped: ISprayLegendsValuesModel[][] = [];
        for (let i = 0; i < values.length; i += groupSize) {
            const group = values.slice(i, i + groupSize);
            // 如果不足 groupSize，则补齐空数据
            while (group.length < groupSize) {
                group.push({ legendCode: '', legendName: '' });
            }
            grouped.push(group);
        }
        return grouped;
    };
    // 按照 legendsGroup 分组
    const groupByLegendsGroup = (
        sprayLegends: ISprayLegendsModel[],
        currentSprayReqData: IFinalSprayDataModel[]
    ): IFinalSprayRenderModel[] => {
        return sprayLegends?.map((legend) => {
            const { legendType, legendValues } = legend;

            const filteredData = currentSprayReqData.filter((item) =>
                item?.legendsGroup === legendType
            );

            console.log('lanxue groupedSpray translateValue',translateValue);
            const tmpTranslateLegendValues = legendValues?.map((item)=>{
                const tmpTranslateName = translateValue?.[item?.legendTranslateCode] || item?.legendName;
                return {
                    ...item,
                    legendName: tmpTranslateName
                };
            });
            const groupLegendValue = groupLegendValues(tmpTranslateLegendValues,3);


            // 构造最终的分组数据
            return {
                legendsGroup: legendType || '',
                currentSprayReqData: filteredData,
                // legendsValues: legendValues || []
                legendsValues: groupLegendValue || []
            };
        });
    };

    const classifyDataByFirstDate = (data: IFinalSprayDataModel[]) => {
        const currentDate = moment().startOf('day'); // 获取当前日期（去掉时间部分）
        const historicalArray = []; // 存储历史数据
        const futureArray = []; // 存储未来数据

        const mixedData = [];
        // filter for mixed value
        const uniqueGroupIdForMixed = Array.from(new Set(allStressAlertReq?.map(item => item.groupIdForMixed)
            ?.filter((value): value is string => value !== undefined)));
        console.log('lanxue change uniqueGroupIdForMixed',uniqueGroupIdForMixed);

        // for forecast and historical group
        data.forEach((item) => {
            const firstDateStr = item?.data?.lstSpray?.[0]?.date?.split(' ')?.[0]; // 提取第一个日期部分
            if (!firstDateStr) {
                console.error('Invalid date array:', item);
                return;
            }

            const firstDate = moment(firstDateStr, finalFormat, true); // 使用严格模式解析日期
            if (!firstDate.isValid()) {
                console.error('Invalid first date:', firstDateStr, 'in item:', item);
                return;
            }

            // 判断第一个日期是否小于当前日期
            if (firstDate.isBefore(currentDate, 'day')) {
                historicalArray.push(item); // 归类为历史数据
            } else {
                futureArray.push(item); // 归类为未来数据
            }
        });

        repeatRequest.forEach((item) => {
            const [modelId, startDate,endDate] = item.split('#');
            const tmpFutureItem = futureArray.find((futureItem) =>
                futureItem?.id === modelId &&
                futureItem?.data?.lstSpray?.[0]?.originDate === startDate &&
                futureItem?.data?.lstSpray?.[futureItem?.data?.lstSpray?.length - 1]?.originDate === endDate);
            const tmpHistoricalItem = historicalArray.find((historicalItem) =>
                historicalItem?.id === modelId &&
                historicalItem?.data?.lstSpray?.[0]?.originDate === startDate &&
                historicalItem?.data?.lstSpray?.[historicalItem?.data?.lstSpray?.length - 1]?.originDate === endDate);
            if(tmpFutureItem){
                futureArray.push(tmpFutureItem);
            }
            if(tmpHistoricalItem){
                historicalArray.push(tmpHistoricalItem);
            }
        });

        const mixedFutureIndex = [];
        const mixedHistoricalIndex = [];

        const maxForecastDate = [];
        const maxHistoricalDate = [];
        uniqueGroupIdForMixed?.forEach((item) => {
            // const groutKeyData = item?.split('-');
            const [historicalDaysStr, forecastDaysStr, modelId] = item.split('-');
            if (!historicalDaysStr || !forecastDaysStr || !modelId) {
                console.warn(`Invalid groupId format: ${item}`);
                return;
            }
            let tmpFutureItem:IFinalSprayDataModel = null;
            let tmpHistoricalItem:IFinalSprayDataModel = null;
            // for future
            for (let itemIndex = 0; futureArray && itemIndex < futureArray.length; itemIndex++) {
                const item = futureArray[itemIndex];
                if (item.id === modelId &&
                    item?.data?.lstSpray?.length === Number(forecastDaysStr) &&
                    !(mixedFutureIndex?.includes(itemIndex))
                ) {
                    tmpFutureItem = item;
                    mixedFutureIndex.push(itemIndex);
                    break; // 找到后立即退出循环
                }
            }
            // futureArray?.forEach((item, itemIndex) => {
            //     if (item.id === modelId && item?.data?.lstSpray?.length === Number(forecastDaysStr)) {
            //         tmpFutureItem = item;
            //         mixedFutureIndex.push(itemIndex);
            //         return;
            //     }
            // });
            // for historical
            for (let itemIndex = 0; historicalArray && itemIndex < historicalArray.length; itemIndex++) {
                const item = historicalArray[itemIndex];
                if (item.id === modelId &&
                    item?.data?.lstSpray?.length === Number(historicalDaysStr) &&
                    !(mixedHistoricalIndex?.includes(itemIndex))
                ) {
                    tmpHistoricalItem = item;
                    mixedHistoricalIndex.push(itemIndex);
                    break; // 找到后立即退出循环
                }
            }
            // historicalArray?.forEach((item, itemIndex) => {
            //     if (item.id === modelId && item?.data?.lstSpray?.length === Number(historicalDaysStr)) {
            //         tmpHistoricalItem = item;
            //         mixedHistoricalIndex.push(itemIndex);
            //         return;
            //     }
            // });
            // set for max date
            // if(tmpFutureItem?.data?.[0].date?.length > maxForecastDate?.length) {
            //     maxForecastDate = [...tmpFutureItem.date];
            // }
            // if(tmpHistoricalItem?.date?.length > maxHistoricalDate?.length) {
            //     maxHistoricalDate = [...tmpHistoricalItem.date];
            // }
            const tmpMixedItem: IFinalSprayDataModel = {
                id: tmpFutureItem?.id || '',
                name: tmpFutureItem?.name || '',
                data: {
                    lstSpray: [...tmpHistoricalItem?.data?.lstSpray || [], ...tmpFutureItem?.data?.lstSpray || []],
                }
            };
            mixedData.push(tmpMixedItem);
            if(tmpFutureItem?.data?.lstSpray?.length >= 1 && currentMixedToday === null) {
                setCurrentMixedToday(tmpFutureItem?.data?.lstSpray?.[0]?.date);
            }
        });

        setCurrentSprayReqDataForMixed(mixedData);
        setCurrentSprayReqDataForForecast(futureArray?.filter((_, index) => !mixedFutureIndex?.includes(index)) || []);
        setCurrentSprayReqDataForHistorical(historicalArray?.filter((_, index) => !mixedHistoricalIndex?.includes(index)) || []);
        // setMaxMixDateArray([...maxHistoricalDate, ...maxForecastDate]);
    };

    useEffect(() => {
        if (showSpray && translateValue) {
            getSprayListDataFunc();
            getTemOptions();
        }
    }, [showSpray, translateValue,finalRequestStressAlertReq]);

    useEffect(()=>{
        if(currentSprayReqData?.length >= 1){
            classifyDataByFirstDate(currentSprayReqData);
        }
    },[currentSprayReqData]);

    useEffect(()=>{
        // Forecast
        if(templateOptions?.spray?.length >= 1 && currentSprayReqDataForForecast?.length >= 1){
            const tmpCurrentSprayReqData = currentSprayReqDataForForecast?.map((item)=>{
                const tmpSpray = templateOptions?.spray?.find((x)=>x.code === item.id);
                return{
                    ...item,
                    legendsGroup: tmpSpray?.legendsGroup
                };
            });
            const groupedData = groupByLegendsGroup(templateOptions.sprayLegends, tmpCurrentSprayReqData);
            setFinalSprayRenderDataForForecast(groupedData);
        }
        // Historical
        if(templateOptions?.spray?.length >= 1 && currentSprayReqDataForHistorical?.length >= 1){
            const tmpCurrentSprayReqData = currentSprayReqDataForHistorical?.map((item)=>{
                const tmpSpray = templateOptions?.spray?.find((x)=>x.code === item.id);
                return{
                    ...item,
                    legendsGroup: tmpSpray?.legendsGroup
                };
            });
            const groupedData = groupByLegendsGroup(templateOptions.sprayLegends, tmpCurrentSprayReqData);
            setFinalSprayRenderDataForHistorical(groupedData);
        }
        // Mixed
        if(templateOptions?.spray?.length >= 1 && currentSprayReqDataForMixed?.length >= 1){
            const tmpCurrentSprayReqData = currentSprayReqDataForMixed?.map((item)=>{
                const tmpSpray = templateOptions?.spray?.find((x)=>x.code === item.id);
                return{
                    ...item,
                    legendsGroup: tmpSpray?.legendsGroup
                };
            });
            const groupedData = groupByLegendsGroup(templateOptions.sprayLegends, tmpCurrentSprayReqData);
            setFinalSprayRenderDataForMixed(groupedData);
        }
    },[templateOptions,currentSprayReqDataForForecast,currentSprayReqDataForHistorical,currentSprayReqDataForMixed]);

    console.log('lanxue currentStressAlertReqData: ', currentSprayReqData);
    console.log('lanxue allStressAlertReq: ', allStressAlertReq);
    console.log('lanxue groupedSpray options: ', templateOptions);
    console.log('lanxue groupedSpray currentSprayReqData: ', currentSprayReqData);
    console.log('lanxue groupedSpray finalSprayRenderData: ', finalSprayRenderData);

    return showSpray ? (
        <div style={{overflow:'auto'}}>
            {/* Forecast and Historical */}
            <IF show={currentSprayReqDataForForecast?.length >= 1 || currentSprayReqDataForHistorical?.length >= 1}>
                <div className="forecast-table content-basic chart-or-table-top">
                    <div className="historical-chart-title common-title">
                        {translateValue?.spray_window || 'Spray Window'}
                    </div>

                    {
                        [...finalSprayRenderDataForForecast,...finalSprayRenderDataForHistorical]?.map((item)=>{
                            if(item?.currentSprayReqData?.length >= 1){
                                return(
                                    <>
                                        {item?.currentSprayReqData?.map((item, index) => {
                                            return (
                                                <>
                                                    <div
                                                        key={`spray-container-${index}-${item?.id}`}
                                                        className="spray-list-container"
                                                    >
                                                        <div className="spray-item-name" style={{ margin: '5px 0px' }}>
                                                            {item?.name}
                                                        </div>
                                                        <table className="spray-table-container">
                                                            <thead>
                                                                <tr>
                                                                    <td className="thead-tr-var basic-first-td">
                                                                        {translateValue?.hours_of_the_day || 'Hours of the day'}
                                                                    </td>
                                                                    {Array.from({ length: 24 }, (_, i) =>
                                                                        i < 10 ? `0${i}` : `${i}`
                                                                    ).map((item) => {
                                                                        return (
                                                                            <>
                                                                                <td className="thead-tr-day basic-td">{item}</td>
                                                                            </>
                                                                        );
                                                                    })}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {item?.data?.lstSpray?.map((item, index) => {
                                                                    return (
                                                                        <>
                                                                            <tr key={index + '-' + item?.date}>
                                                                                <td className="tdoby-tr-var basic-first-td">
                                                                                    {/* {`${item?.date} ${moment(item?.date,'MM/DD/yyyy').format('ddd')}`} */}
                                                                                    {`${item?.date}`}
                                                                                </td>
                                                                                {/* show detail value */}
                                                                                {item?.lstHourData?.map((innerItem, innerIndex) => {
                                                                                    return (
                                                                                        <td
                                                                                            key={innerItem?.hour + '-' + innerIndex}
                                                                                            className="tdoby-tr-day basic-td"
                                                                                            style={{
                                                                                                backgroundColor: innerItem?.backColor,
                                                                                            }}
                                                                                        >
                                                                                            {innerItem?.srl}
                                                                                        </td>
                                                                                    );
                                                                                })}
                                                                            </tr>
                                                                        </>
                                                                    );
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </>
                                            );
                                        })}

                                        {/* @* Color Legend *@ */}
                                        <div className="new-color-legend">
                                            <table className="color-legend-table">
                                                <thead>
                                                    <tr className="color-first-tr">
                                                        <td colSpan={6}>
                                                            {translateValue?.color_legend || 'Color Legend'}
                                                        </td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <div
                                                                className="square"
                                                                style={{ backgroundColor: 'rgb(65, 195, 4)' }}
                                                            ></div>
                                                        </td>
                                                        <td>
                                                            <span>{translateValue?.recommended || 'Recommended'}</span>
                                                        </td>
                                                        <td>
                                                            <div
                                                                className="square"
                                                                style={{ backgroundColor: 'rgb(225, 122, 0)' }}
                                                            ></div>
                                                        </td>
                                                        <td>
                                                            {' '}
                                                            <span>{translateValue?.limited || 'Limited'}</span>
                                                        </td>
                                                        <td>
                                                            <div
                                                                className="square"
                                                                style={{ backgroundColor: 'rgb(238, 26, 26)' }}
                                                            ></div>
                                                        </td>
                                                        <td>
                                                            <span>{translateValue?.not_advisable || 'Not Advisable'}</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* @* Restrictions Legend *@ */}
                                        <div className="restrictions-legend">
                                            <table className="restrictions-legend-table">
                                                <thead>
                                                    <tr className="restrictions-first-tr">
                                                        <td colSpan={6}>
                                                            {translateValue?.restrictions_legend || 'Restrictions Legend'}
                                                        </td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        item?.legendsValues?.map((legendItem, index) => {
                                                            return(
                                                                <>
                                                                    <tr>
                                                                        {
                                                                            legendItem?.map((innerItem, innerIndex) => {
                                                                                return(
                                                                                    <>
                                                                                        <td>{innerItem?.legendCode}</td>
                                                                                        <td>{innerItem?.legendName}</td>
                                                                                    </>
                                                                                );
                                                                            })
                                                                        }
                                                                    </tr>
                                                                </>
                                                            );
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                                );
                            }
                            else{
                                return null;
                            }

                        })
                    }


                </div>
            </IF>

            {/* Mixed */}
            <IF show={currentSprayReqDataForMixed?.length >= 1}>
                <div className="forecast-table content-basic chart-or-table-top">
                    <div className="historical-chart-title common-title">
                        {translateValue?.spray_window || 'Spray Window'} {` - ${translateValue?.forecast + ' ' + translateValue?.and + ' ' + translateValue?.historical}`}
                    </div>

                    {
                        finalSprayRenderDataForMixed?.map((item)=>{
                            if(item?.currentSprayReqData?.length >= 1){
                                return(
                                    <>
                                        {item?.currentSprayReqData?.map((item, index) => {
                                            return (
                                                <>
                                                    <div
                                                        key={`spray-container-${index}-${item?.id}`}
                                                        className="spray-list-container"
                                                    >
                                                        <div className="spray-item-name" style={{ margin: '5px 0px' }}>
                                                            {item?.name}
                                                        </div>
                                                        <table className="spray-table-container">
                                                            <thead>
                                                                <tr>
                                                                    <td className="thead-tr-var basic-first-td">
                                                                        {translateValue?.hours_of_the_day || 'Hours of the day'}
                                                                    </td>
                                                                    {Array.from({ length: 24 }, (_, i) =>
                                                                        i < 10 ? `0${i}` : `${i}`
                                                                    ).map((item) => {
                                                                        return (
                                                                            <>
                                                                                <td className="thead-tr-day basic-td">{item}</td>
                                                                            </>
                                                                        );
                                                                    })}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {item?.data?.lstSpray?.map((item, index) => {
                                                                    return (
                                                                        <>
                                                                            <tr key={index + '-' + item?.date}>
                                                                                <td className="tdoby-tr-var basic-first-td"
                                                                                    style={{
                                                                                        fontWeight: `${item?.date === currentMixedToday ? 800 : 400}`,
                                                                                    }}
                                                                                >
                                                                                    {/* {`${item?.date} ${moment(item?.date,'MM/DD/yyyy').format('ddd')}`} */}
                                                                                    {`${item?.date}`}
                                                                                </td>
                                                                                {/* show detail value */}
                                                                                {item?.lstHourData?.map((innerItem, innerIndex) => {
                                                                                    return (
                                                                                        <td
                                                                                            key={innerItem?.hour + '-' + innerIndex}
                                                                                            className="tdoby-tr-day basic-td"
                                                                                            style={{
                                                                                                backgroundColor: innerItem?.backColor,
                                                                                            }}
                                                                                        >
                                                                                            {innerItem?.srl}
                                                                                        </td>
                                                                                    );
                                                                                })}
                                                                            </tr>
                                                                        </>
                                                                    );
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </>
                                            );
                                        })}

                                        {/* @* Color Legend *@ */}
                                        <div className="new-color-legend">
                                            <table className="color-legend-table">
                                                <thead>
                                                    <tr className="color-first-tr">
                                                        <td colSpan={6}>
                                                            {translateValue?.color_legend || 'Color Legend'}
                                                        </td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <div
                                                                className="square"
                                                                style={{ backgroundColor: 'rgb(65, 195, 4)' }}
                                                            ></div>
                                                        </td>
                                                        <td>
                                                            <span>{translateValue?.recommended || 'Recommended'}</span>
                                                        </td>
                                                        <td>
                                                            <div
                                                                className="square"
                                                                style={{ backgroundColor: 'rgb(225, 122, 0)' }}
                                                            ></div>
                                                        </td>
                                                        <td>
                                                            {' '}
                                                            <span>{translateValue?.limited || 'Limited'}</span>
                                                        </td>
                                                        <td>
                                                            <div
                                                                className="square"
                                                                style={{ backgroundColor: 'rgb(238, 26, 26)' }}
                                                            ></div>
                                                        </td>
                                                        <td>
                                                            <span>{translateValue?.not_advisable || 'Not Advisable'}</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* @* Restrictions Legend *@ */}
                                        <div className="restrictions-legend">
                                            <table className="restrictions-legend-table">
                                                <thead>
                                                    <tr className="restrictions-first-tr">
                                                        <td colSpan={6}>
                                                            {translateValue?.restrictions_legend || 'Restrictions Legend'}
                                                        </td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        item?.legendsValues?.map((legendItem, index) => {
                                                            return(
                                                                <>
                                                                    <tr>
                                                                        {
                                                                            legendItem?.map((innerItem, innerIndex) => {
                                                                                return(
                                                                                    <>
                                                                                        <td>{innerItem?.legendCode}</td>
                                                                                        <td>{innerItem?.legendName}</td>
                                                                                    </>
                                                                                );
                                                                            })
                                                                        }
                                                                    </tr>
                                                                </>
                                                            );
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                                );
                            }
                            else{
                                return null;
                            }

                        })
                    }


                </div>
            </IF>

        </div>
    ) : null;
};

export default TemplateSpray;
